var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:`d-flex flex-column ${_vm.className ?? ''}`},[_c('div',{staticClass:"d-flex justify-space-between white--text mb-1 item-col__title"},[_vm._v(" "+_vm._s(_vm.title)+" ")]),_vm._l((_vm.description.split('\n')),function(option,idx){return _c('div',{key:idx,staticClass:"item-col__description"},[_vm._v(" "+_vm._s(option)+" ")])})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }